import {
  faBell,
  faChartLine,
  faCheckDouble,
  faCog,
  faDisplay,
  faDumbbell,
  faHeartPulse,
  faList,
  faMessage,
  faShareAlt,
  faTowerBroadcast,
  faRightFromBracket,
  faUpload,
  faUser,
  faUsers,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { HpButton } from "../HpButton/HpButton";

import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuItem from "./MenuItem";
import DropdownMenuItem from "./DropdownMenuItem";
import SubMenuItem from "./SubMenuItem";
import ActiveIndicator from "./ActiveIndicator";

import axios from "axios";
import $ from "jquery";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, FormSelect } from "shards-react";
import Cookies from "universal-cookie";
import logo_color from "../../Images/logo_color.png";
import female_profile from "../../Images/female_profile.png";
import male_profile from "../../Images/male_profile.png";
import API from "../Api/API";
import AsyncImage from "../AsyncImage/AsyncImage";
import {
  default as AuthService,
  default as authService,
} from "../AuthService/AuthService";
import LanguageSelector from "../LanguageSelector/LanguageSelector";

import "dear-image.detect-background-color";
import DearImage from "dear-image";
import { showNotification } from "../Notification/Notification";
import HpModal from "../Modal/HpModal";
import MessageForm from "../MessageForm/MessageForm";
import CoachContactForm from "../Coach/CoachContactForm";

const Sidebar = ({
  primaryColor,
  isAdmin,
  isClubManager,
  isSquadManager,
  isExerciseManager,
  isUser,
  noClubs,
  setNoClubs,
  setColorRefresh,
  isExpired,
  setIsExpired,
  setAfterExpiration,
  globalSquad,
  setGlobalSquad,
  setGlobalClub,
  setDashboardSquadId,
  setGlobalUser,
  sidebarRefresh,
  setSquadResultsShow,
  isRightClubManager,
  isRightSquadManager,
  setIsRightClubManager,
  setIsRightSquadManager,
  isRightUser,
  setIsRightUser,
  isIndividual,
}) => {
  const navigate = useNavigate();
  const navListRef = useRef(null);
  const location = useLocation();

  const getPageName = () => {
    const path = location.pathname.substring(1);
    const map = {
      "": t("overview"),
      userdashboard: t("user_dashboard"),
      clubdashboard: t("club_dashboard"),
      squad: t("squads"),
      testresults: t("results"),
      testoverview: t("results"),
      clubresults: t("results"),
      squadresults: t("results"),
      clubtestoverview: t("results"),
      editsquadresults: t("tests"),
      editassignedexercises: t("exercises"),
      assignedexercises: t("exercises"),
      healthrecords: t("health_records"),
      shareddocuments: t("documents"),
      sharedphotos: t("photos"),
      sharedvideos: t("videos"),
      "import/tanita": t("import"),
      exercisemanagement: t("exercise_management"),
      testmanagement: t("test_management"),
      clubmanagement: t("club_management"),
      useroverview: t("users_overview"),
      sales: t("sales"),
      settings: t("profile"),
    };
    return map[path] ?? "";
  };

  const [refresh, setRefresh] = useState(false);

  const [clubs, setClubs] = useState([]);

  const [activeSquadResultsTab, setActiveSquadResultsTab] = useState("");

  const [activeClub, setActiveClub] = useState();

  const [squadsForUser, setSquadsForUser] = useState([]);

  const [managedSquads, setManagedSquads] = useState([]);
  const [selectedSquadId, setSelectedSquadId] = useState(null);

  const [notifications, setNotifications] = useState([]);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [activeUser, setActiveUser] = useState();
  const [currentUserProfile, setCurrentUserProfile] = useState(null);

  const { i18n, t } = useTranslation(["sidebar", "message", "coach"]);

  useEffect(() => {
    const getData = async () => {
      AuthService.checkExpiration().then(async () => {
        const response = await fetchClubs();
        let sorted = response.sort((a, b) =>
          a.name.localeCompare(b.name, i18n.language),
        );

        const cookies = new Cookies();

        if (sorted.length === 0) {
          setNoClubs(true);
          cookies.remove("selectedClubId");
          cookies.remove("primaryColor");
          cookies.remove("secondaryColor");
          cookies.remove("tertiaryColor");
          setColorRefresh((c) => !c);
        } else {
          setNoClubs(false);
          setClubs(sorted);
          const clubId = parseInt(cookies.get("selectedClubId"));
          if (clubId) {
            let found = false;
            let i = 0;
            for (i; i < sorted.length; i++) {
              if (sorted[i].id === clubId) {
                found = true;
                break;
              }
            }
            let club;
            if (found) {
              $("#club_select").val(clubId);
              club = sorted.find((c) => c.id === clubId);
            } else {
              club = sorted[0];
            }
            club.squads.sort((a, b) =>
              a.name.localeCompare(b.name, i18n.language),
            );

            const index = club.squads.findIndex((s) => s.id === 0);
            if (index !== -1) {
              const squad = club.squads[index];
              club.squads.splice(index, 1);
              club.squads.push(squad);
            }

            club.squads.forEach((squad) => {
              squad.members.sort((a, b) =>
                (a.lastName + " " + a.firstName).localeCompare(
                  b.lastName + " " + b.firstName,
                  i18n.language,
                ),
              );
            });

            if (globalSquad) {
              const squad = club.squads.find((s) => s.id === globalSquad.id);
              setGlobalSquad(squad);
            }

            setActiveClub(club);
            setGlobalClub(club);
            cookies.set("selectedClubId", club.id, {
              expires: new Date(moment().add(365, "d").format()),
            });
            const colorExpiry = {
              expires: new Date(moment().add(365, "d").format()),
            };
            if (club.primaryColor) {
              cookies.set("primaryColor", club.primaryColor, colorExpiry);
            } else {
              cookies.remove("primaryColor");
            }
            if (club.secondaryColor) {
              cookies.set("secondaryColor", club.secondaryColor, colorExpiry);
            } else {
              cookies.remove("secondaryColor");
            }
            if (club.tertiaryColor) {
              cookies.set("tertiaryColor", club.tertiaryColor, colorExpiry);
            } else {
              cookies.remove("tertiaryColor");
            }

            setColorRefresh((c) => !c);

            if (isIndividual) {
              const user = await fetchUser();
              if (
                !user.individualSubscriptionExpiration ||
                new Date(
                  user.individualSubscriptionExpiration.replace(/ /g, "T"),
                ) < new Date()
              ) {
                setAfterExpiration(true);
                const threeDays = new Date(
                  user.individualSubscriptionExpiration
                    ? user.individualSubscriptionExpiration.replace(/ /g, "T")
                    : "1970-01-01",
                );
                threeDays.setDate(threeDays.getDate() + 3);
                if (threeDays < new Date()) {
                  setIsExpired(true);
                  const url = window.location.href;
                  if (
                    !url.includes("subscription") &&
                    !url.includes("payment")
                  ) {
                    setGlobalUser(user);
                    navigate("/subscription");
                  }
                }
              }
            } else {
              if (
                !club.subscriptionExpiration ||
                new Date(club.subscriptionExpiration.replace(/ /g, "T")) <
                  new Date()
              ) {
                setAfterExpiration(true);
                const threeDays = new Date(
                  club.subscriptionExpiration
                    ? club.subscriptionExpiration.replace(/ /g, "T")
                    : "1970-01-01",
                );
                threeDays.setDate(threeDays.getDate() + 3);
                if (threeDays < new Date()) {
                  setIsExpired(true);
                  const url = window.location.href;
                  if (
                    !url.includes("subscription") &&
                    !url.includes("payment")
                  ) {
                    setGlobalClub(club);
                    navigate("/clubsubscription");
                  }
                }
              }
            }
          }
        }
      });
    };
    getData();
  }, [
    setNoClubs,
    setColorRefresh,
    setIsExpired,
    setAfterExpiration,
    sidebarRefresh,
  ]);

  useEffect(() => {
    const fetchAndSetUser = async () => {
      if (isIndividual) {
        const user = await fetchUser();
        if (user.photoPath === null) {
          if (user.sex === "FEMALE") user.photoSrc = female_profile;
          else user.photoSrc = male_profile;
        }
        setActiveUser(user);
      }
    };
    fetchAndSetUser();
  }, [isIndividual]);

  useEffect(() => {
    if (activeUser) {
      setCurrentUserProfile(activeUser);
      return;
    }
    if (!activeClub) return;
    const uid = parseInt(authService.getUserId());
    let found = activeClub.managers?.find((m) => m.id === uid);
    if (!found) {
      for (const squad of activeClub.squads || []) {
        found = squad.managers?.find((m) => m.id === uid);
        if (found) break;
      }
    }
    if (!found) {
      for (const squad of activeClub.squads || []) {
        found = squad.members?.find((m) => m.id === uid);
        if (found) break;
      }
    }
    if (found) setCurrentUserProfile(found);
  }, [activeClub, activeUser]);

  useEffect(() => {
    if (activeClub) {
      const userId = authService.getUserId();
      let alreadySet = false;
      if (isClubManager) {
        if (activeClub.managers.find((m) => m.id === userId)) {
          setIsRightClubManager(true);
          setIsRightSquadManager(true);
          setSquadsForUser(activeClub.squads);
          alreadySet = true;
        }
      }

      if (!alreadySet && isSquadManager) {
        if (activeClub.squads) {
          const squads = activeClub.squads.filter((squad) => {
            return !!squad.managers?.find((m) => m.id === userId);
          });
          setSquadsForUser(squads);
          setIsRightSquadManager(squads.length > 0);
        }
      }

      if (isUser) {
        const userSquads = activeClub.squads.filter((squad) => {
          return !!squad.members.find((m) => m.id === userId);
        });
        setIsRightUser(userSquads.length > 0);
      }

      const filtered = activeClub.squads
        .filter(
          (squad) =>
            squad.id > 0 &&
            (alreadySet ||
              squad.managers?.some((manager) => manager.id === userId)),
        )
        .sort((a, b) => a.name.localeCompare(b.name));
      setManagedSquads(filtered);

      const cookies = new Cookies();
      const cookieSquadId = parseInt(cookies.get("selectedSquadId"));
      const squadToSelect =
        filtered.find((s) => s.id === cookieSquadId) || filtered[0];
      if (squadToSelect) {
        setSelectedSquadId(squadToSelect.id);
        setGlobalSquad(squadToSelect);
        setDashboardSquadId(squadToSelect.id);
      }
    }
  }, [activeClub, isClubManager, isSquadManager]);

  useEffect(() => {
    if (activeClub && activeClub.id > -1) {
      const getData = async () => {
        const response = await fetchNotifications(activeClub.id);
        setNotifications(response);
        const unshownNotif = response.find((n) => !n.shown);
        if (unshownNotif) {
          showNotification(unshownNotif.description, 5000);
          setNotificationShown(unshownNotif.id);
        }
      };
      getData();
    } else {
      const getData = async () => {
        const response = await fetchNotifications(0);
        setNotifications(response);
        const unshownNotif = response.find((n) => !n.shown);
        if (unshownNotif) {
          showNotification(unshownNotif.description, 5000);
          setNotificationShown(unshownNotif.id);
        }
      };
      getData();
    }
  }, [refresh, activeClub]);

  const fetchClubs = async () => {
    return axios
      .get(API.url + "api/club/allforuser", { withCredentials: true })
      .then((res) => res.data)
      .catch(() => AuthService.logout());
  };

  const fetchUser = async () => {
    return axios
      .get(API.url + "api/user/details", { withCredentials: true })
      .then((res) => res.data)
      .catch(() => AuthService.logout());
  };

  const fetchNotifications = async (clubId) => {
    const url = isIndividual
      ? API.url + "api/notification/individual/unread"
      : API.url + "api/notification/unread/" + clubId;
    return axios
      .get(url, { withCredentials: true })
      .then((res) => res.data)
      .catch(() => []);
  };

  const setNotificationShown = async (id) => {
    return axios.put(API.url + "api/notification/markAsShown/" + id, null, {
      withCredentials: true,
    });
  };

  const selectColor = {
    // color: "white",
    borderColor: primaryColor,
  };

  const [messageOpen, setMessageOpen] = useState(false);
  const [coachContactOpen, setCoachContactOpen] = useState(false);

  const toggleSidebar = () => {
    document.getElementById("sidebar").classList.toggle("active");
    setSidebarOpen((o) => !o);
  };

  const changeClubId = (e) => {
    e.preventDefault();
    const cookies = new Cookies();
    cookies.set("selectedClubId", e.target.value, {
      expires: new Date(moment().add(365, "d").format()),
    });

    window.location = "/";
  };

  const changeSquadId = (e) => {
    const id = parseInt(e.target.value);
    const cookies = new Cookies();
    cookies.set("selectedSquadId", id, {
      expires: new Date(moment().add(365, "d").format()),
    });
    const squad = managedSquads.find((s) => s.id === id);
    if (squad) {
      setSelectedSquadId(id);
      setGlobalSquad(squad);
      setDashboardSquadId(id);
    }
  };

  return [
    <div className="sidebar-frame" key="sidebar-frame" />,
    <div className="topbar-frame" key="topbar-frame">
      <div
        className="topbar"
        style={{ backgroundColor: "var(--secondary-color)" }}
      >
        {activeClub && activeClub.logoPath ? (
          <div
            className="club-logo-wrapper"
            onClick={() => {
              document.getElementById("sidebar").classList.remove("active");
              navigate("/");
              setRefresh((r) => !r);
            }}
          >
            <AsyncImage
              className="club-logo"
              src={API.url + "api/club/download/" + activeClub.id}
              onLoad={async (e) => {
                const image = e.target;
                image.parentNode.style.backgroundColor =
                  await DearImage.detectBackgroundColor(image);
              }}
            />
          </div>
        ) : (
          <img
            className="club-logo logo-hp"
            src={logo_color}
            alt="Health Profile"
            onClick={() => {
              document.getElementById("sidebar").classList.remove("active");
              navigate("/");
              setRefresh((r) => !r);
            }}
          />
        )}
        <span className="topbar-page-name">{getPageName()}</span>
        <div className="navbar-right-group">
          <div className="desktop-navbar-buttons">
            <div
              className="shortcut-button"
              onClick={() => {
                setRefresh((r) => !r);
                setGlobalClub(activeClub);
                navigate("/notifications");
              }}
            >
              <FontAwesomeIcon icon={faBell} />
              {notifications.length > 0 && (
                <div className="notification-badge">
                  {notifications.length > 9 ? "9+" : notifications.length}
                </div>
              )}
            </div>

            {(isRightSquadManager || isRightClubManager) && (
              <div
                className="shortcut-button"
                onClick={() => {
                  setRefresh((r) => !r);
                  setMessageOpen(true);
                }}
              >
                <FontAwesomeIcon icon={faMessage} />
              </div>
            )}
            {isIndividual && (
              <div
                className="shortcut-button"
                onClick={() => {
                  setRefresh((r) => !r);
                  setCoachContactOpen(true);
                }}
              >
                <FontAwesomeIcon icon={faMessage} />
              </div>
            )}

            <div
              className="shortcut-button profile-button"
              onClick={() => {
                setRefresh((r) => !r);
                setGlobalClub(activeClub);
                navigate("/settings");
              }}
            >
              {currentUserProfile ? (
                <>
                  <div className="topbar-avatar">
                    {currentUserProfile.photoPath ? (
                      <AsyncImage
                        src={
                          API.url + "api/user/download/" + currentUserProfile.id
                        }
                        className="topbar-avatar-img"
                      />
                    ) : (
                      <img
                        src={
                          currentUserProfile.sex === "FEMALE"
                            ? female_profile
                            : male_profile
                        }
                        className="topbar-avatar-img"
                        alt=""
                      />
                    )}
                  </div>
                  <span className="topbar-username">
                    {currentUserProfile.firstName} {currentUserProfile.lastName}
                  </span>
                </>
              ) : (
                <FontAwesomeIcon icon={faUser} />
              )}
            </div>
            <div
              className="shortcut-button sidebar-toggle-btn"
              onClick={toggleSidebar}
              style={
                sidebarOpen
                  ? {
                      backgroundColor: primaryColor,
                      color: "white",
                      opacity: 1,
                    }
                  : {}
              }
            >
              <FontAwesomeIcon icon={sidebarOpen ? faXmark : faList} id="btn" />
            </div>
          </div>
        </div>
      </div>
    </div>,
    <div
      className="sidebar"
      id="sidebar"
      key="sidebar"
      style={{ backgroundColor: "var(--secondary-color)" }}
    >
      <div className="sidebar-content-wrapper">
        <div className="sidebar-scroll-section">
          <div className="sidebar-header-content">
            {activeClub &&
              (activeUser ? (
                <div
                  className="logo_content club_logo_content"
                  onClick={() => {
                    document
                      .getElementById("sidebar")
                      .classList.remove("active");
                    setRefresh((r) => !r);
                    setGlobalClub(activeClub);
                    navigate("/settings");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="logo club_logo user_logo">
                    {activeUser.photoPath ? (
                      <AsyncImage src={API.url + "api/user/download"} />
                    ) : (
                      <img src={activeUser.photoSrc} alt="" />
                    )}
                  </div>
                </div>
              ) : (
                activeClub.logoPath && (
                  <div
                    className="logo_content club_logo_content"
                    onClick={() => {
                      document
                        .getElementById("sidebar")
                        .classList.remove("active");
                      navigate("/");
                      setRefresh((r) => !r);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="logo club_logo">
                      <AsyncImage
                        src={API.url + "api/club/download/" + activeClub.id}
                        onLoad={async (e) => {
                          const image = e.target;
                          image.parentNode.style.backgroundColor =
                            await DearImage.detectBackgroundColor(image);
                        }}
                      />
                    </div>
                  </div>
                )
              ))}
            {clubs.length > 1 && (
              <div className="club_select">
                <FormSelect
                  id="club_select"
                  style={selectColor}
                  onChange={changeClubId}
                  defaultValue={activeClub?.id}
                >
                  {clubs.map((club, index) => (
                    <option key={"club_" + club.id} value={club.id}>
                      {club.name}
                    </option>
                  ))}
                </FormSelect>
              </div>
            )}
            {(isRightClubManager || isRightSquadManager) &&
              managedSquads.length > 1 && (
                <div className="club_select">
                  <FormSelect
                    id="squad_select"
                    style={selectColor}
                    onChange={changeSquadId}
                    value={selectedSquadId ?? ""}
                  >
                    {managedSquads.map((squad) => (
                      <option key={"squad_" + squad.id} value={squad.id}>
                        {squad.name}
                      </option>
                    ))}
                  </FormSelect>
                </div>
              )}
          </div>
          <div className="nav_list_wrapper" ref={navListRef}>
            <ActiveIndicator containerRef={navListRef} />
            <ul className="nav_list">
              {(isRightClubManager || isRightSquadManager || isRightUser) &&
                !isExpired &&
                ((isRightClubManager || isRightSquadManager) && isRightUser ? (
                  <DropdownMenuItem
                    icon={faDisplay}
                    text={t("overview")}
                    href="/"
                    subPaths={["/clubdashboard", "/userdashboard"]}
                    setRefresh={setRefresh}
                    onItemClick={() => setGlobalClub(activeClub)}
                  >
                    <SubMenuItem href="/clubdashboard" setRefresh={setRefresh}>
                      {t("club_dashboard")}
                    </SubMenuItem>
                    <SubMenuItem href="/userdashboard" setRefresh={setRefresh}>
                      {t("user_dashboard")}
                    </SubMenuItem>
                  </DropdownMenuItem>
                ) : (
                  <MenuItem
                    icon={faDisplay}
                    text={t("overview")}
                    href="/"
                    setRefresh={setRefresh}
                    clickEvent={() => setGlobalClub(activeClub)}
                  />
                ))}
              {!noClubs && (isRightSquadManager || isRightClubManager) && (
                <MenuItem
                  icon={faUsers}
                  text={t("squads")}
                  href="/squad"
                  setRefresh={setRefresh}
                  clickEvent={() => setGlobalClub(activeClub)}
                />
              )}
              {!noClubs &&
                !isExpired &&
                (isRightSquadManager || isRightClubManager || isRightUser) && (
                  <DropdownMenuItem
                    icon={faChartLine}
                    text={t("results")}
                    href="/testresults"
                    subPaths={[
                      "/testoverview",
                      "/clubresults",
                      "/squadresults",
                      "/clubtestoverview",
                    ]}
                    setRefresh={setRefresh}
                  >
                    {isRightUser && (
                      <>
                        <SubMenuItem
                          href="/testresults"
                          setRefresh={setRefresh}
                        >
                          {t(
                            isRightClubManager || isRightSquadManager
                              ? "my_test_results"
                              : "test_results",
                          )}
                        </SubMenuItem>
                        <SubMenuItem
                          href="/testoverview"
                          setRefresh={setRefresh}
                        >
                          {t(
                            t(
                              isRightClubManager || isRightSquadManager
                                ? "my_test_overview"
                                : "test_overview",
                            ),
                          )}
                        </SubMenuItem>
                      </>
                    )}
                    {(isRightClubManager || isRightSquadManager) && (
                      <>
                        <SubMenuItem
                          href="/squadresults"
                          active={activeSquadResultsTab === "quadrants"}
                          setRefresh={setRefresh}
                          onClick={() => {
                            setSquadResultsShow("quadrants");
                            setActiveSquadResultsTab("quadrants");
                            navigate("/squadresults");
                          }}
                        >
                          {t("quadrant_graphs")}
                        </SubMenuItem>
                        <SubMenuItem
                          href="/squadresults"
                          active={activeSquadResultsTab === "rpe"}
                          setRefresh={setRefresh}
                          onClick={() => {
                            setSquadResultsShow("rpe");
                            setActiveSquadResultsTab("rpe");
                            navigate("/squadresults");
                          }}
                        >
                          {t("rpe_records")}
                        </SubMenuItem>
                        <SubMenuItem
                          href="/squadresults"
                          active={activeSquadResultsTab === "compare"}
                          setRefresh={setRefresh}
                          onClick={() => {
                            setSquadResultsShow("compare");
                            setActiveSquadResultsTab("compare");
                            navigate("/squadresults");
                          }}
                        >
                          {t("squad_compare")}
                        </SubMenuItem>
                        <SubMenuItem
                          href="/squadresults"
                          active={activeSquadResultsTab === "health_records"}
                          setRefresh={setRefresh}
                          onClick={() => {
                            setSquadResultsShow("health_records");
                            setActiveSquadResultsTab("health_records");
                            navigate("/squadresults");
                          }}
                        >
                          {t("injury_overview")}
                        </SubMenuItem>
                        <SubMenuItem
                          href="/clubtestoverview"
                          setRefresh={setRefresh}
                        >
                          {t(t("test_overview"))}
                        </SubMenuItem>
                      </>
                    )}
                    {isRightClubManager && (
                      <SubMenuItem href="/clubresults" setRefresh={setRefresh}>
                        {t("club_results")}
                      </SubMenuItem>
                    )}
                  </DropdownMenuItem>
                )}
              {!noClubs &&
                !isExpired &&
                (isRightSquadManager || isRightClubManager) && (
                  <MenuItem
                    icon={faCheckDouble}
                    text={t("tests")}
                    href="/editsquadresults"
                    setRefresh={setRefresh}
                  />
                )}
              {!noClubs &&
                !isExpired &&
                (isRightSquadManager || isRightClubManager || isRightUser) &&
                ((isRightSquadManager || isRightClubManager) && isRightUser ? (
                  <DropdownMenuItem
                    icon={faDumbbell}
                    text={t("exercises")}
                    subPaths={["/assignedexercises", "/editassignedexercises"]}
                    setRefresh={setRefresh}
                  >
                    <SubMenuItem
                      href="/assignedexercises"
                      setRefresh={setRefresh}
                    >
                      {t("my_assigned_exercises")}
                    </SubMenuItem>
                    <SubMenuItem
                      href="/editassignedexercises"
                      setRefresh={setRefresh}
                    >
                      {t("whole_squad")}
                    </SubMenuItem>
                  </DropdownMenuItem>
                ) : (
                  <MenuItem
                    icon={faDumbbell}
                    text={t("exercises")}
                    href={
                      isRightUser
                        ? "/assignedexercises"
                        : "/editassignedexercises"
                    }
                    setRefresh={setRefresh}
                  />
                ))}
              {isRightUser && !isExpired && (
                <MenuItem
                  icon={faHeartPulse}
                  text={t("health_records")}
                  href="/healthrecords"
                  setRefresh={setRefresh}
                />
              )}
              {!noClubs &&
                !isExpired &&
                (isRightSquadManager || isRightClubManager || isRightUser) && (
                  <DropdownMenuItem
                    icon={faShareAlt}
                    text={
                      isRightClubManager || isRightSquadManager
                        ? t("sharing")
                        : t("files")
                    }
                    subPaths={[
                      "/shareddocuments",
                      "/sharedphotos",
                      "/sharedvideos",
                    ]}
                    setRefresh={setRefresh}
                  >
                    <SubMenuItem
                      href="/shareddocuments"
                      setRefresh={setRefresh}
                    >
                      {t("documents")}
                    </SubMenuItem>
                    <SubMenuItem href="/sharedphotos" setRefresh={setRefresh}>
                      {t("photos")}
                    </SubMenuItem>
                    <SubMenuItem href="/sharedvideos" setRefresh={setRefresh}>
                      {t("videos")}
                    </SubMenuItem>
                  </DropdownMenuItem>
                )}
              {/* {!noClubs && (isSquadManager || isClubManager) && (
            <MenuItem
              id="item_club"
              icon={faShieldAlt}
              text={t("club")}
              href="/club"
              primaryColor={primaryColor}
              textColor={primaryColor}
              navigate={navigate}
              setRefresh={setRefresh}
            />
          )} */}
              {(isClubManager || isSquadManager || isIndividual) &&
                !isExpired && (
                  <DropdownMenuItem
                    icon={faUpload}
                    text={t("import")}
                    subPaths={["/import/tanita"]}
                    setRefresh={setRefresh}
                  >
                    <SubMenuItem href="/import/tanita" setRefresh={setRefresh}>
                      Tanita
                    </SubMenuItem>
                  </DropdownMenuItem>
                )}
              {!isExpired &&
                (isExerciseManager || isRightClubManager || isAdmin) &&
                (isAdmin ? (
                  <DropdownMenuItem
                    icon={faCog}
                    text={t("management")}
                    href="/exercisemanagement"
                    subPaths={[
                      "/testmanagement",
                      "/clubmanagement",
                      "/useroverview",
                    ]}
                    setRefresh={setRefresh}
                  >
                    <SubMenuItem
                      href="/exercisemanagement"
                      setRefresh={setRefresh}
                    >
                      {t("exercise_management")}
                    </SubMenuItem>
                    <SubMenuItem href="/testmanagement" setRefresh={setRefresh}>
                      {t("test_management")}
                    </SubMenuItem>
                    <SubMenuItem href="/clubmanagement" setRefresh={setRefresh}>
                      {t("club_management")}
                    </SubMenuItem>
                    <SubMenuItem href="/useroverview" setRefresh={setRefresh}>
                      {t("users_overview")}
                    </SubMenuItem>
                  </DropdownMenuItem>
                ) : (
                  <MenuItem
                    icon={faDumbbell}
                    text={t("exercise_management")}
                    href="/exercisemanagement"
                    setRefresh={setRefresh}
                  />
                ))}
              <li id={"item_blog"}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://healthprofile.digital/blog/"
                >
                  <FontAwesomeIcon icon={faTowerBroadcast} />
                  <span className="links_name">{t("blog")}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="sidebar-bottom-container">
          <div className="shortcut-buttons-container">
            <div
              className="shortcut-button"
              onClick={() => {
                document.getElementById("sidebar").classList.remove("active");
                setRefresh((r) => !r);
                setGlobalClub(activeClub);
                navigate("/notifications");
              }}
            >
              <FontAwesomeIcon icon={faBell} />
              {notifications.length > 0 && (
                <div className="notification-badge">
                  {notifications.length > 9 ? "9+" : notifications.length}
                </div>
              )}
            </div>
            <div
              className="shortcut-button"
              onClick={() => {
                document.getElementById("sidebar").classList.remove("active");
                setRefresh((r) => !r);
                setGlobalClub(activeClub);
                navigate("/settings");
              }}
            >
              <FontAwesomeIcon icon={faUser} />
            </div>
            {(isRightSquadManager || isRightClubManager) && (
              <div
                className="shortcut-button"
                onClick={() => {
                  document.getElementById("sidebar").classList.remove("active");
                  setRefresh((r) => !r);
                  setMessageOpen(true);
                }}
              >
                <FontAwesomeIcon icon={faMessage} />
              </div>
            )}
            {isIndividual && (
              <div
                className="shortcut-button"
                onClick={() => {
                  document.getElementById("sidebar").classList.remove("active");
                  setRefresh((r) => !r);
                  setCoachContactOpen(true);
                }}
              >
                <FontAwesomeIcon icon={faMessage} />
              </div>
            )}
          </div>
          <button className="sidebar-logout-btn" onClick={AuthService.logout}>
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>{t("logout")}</span>
          </button>
          <div className="language_container">
            <LanguageSelector />
          </div>
          <div className="sidebar-hp-logo">
            <img src={logo_color} alt="Health Profile" />
          </div>
        </div>
      </div>
    </div>,
    (isRightSquadManager || isRightClubManager) && (
      <HpModal
        key="message-modal"
        open={messageOpen}
        toggle={() => setMessageOpen((p) => !p)}
        title={t("new_message", { ns: "message" })}
        size="lg"
        body={() => (
          <MessageForm
            primaryColor={primaryColor}
            isClubManager={isClubManager}
            embedded
            onClose={() => setMessageOpen(false)}
          />
        )}
        actions={() => (
          <HpButton
            form="message-form-embedded"
            type="submit"
            squared
            size="lg"
          >
            {t("send", { ns: "message" })}
          </HpButton>
        )}
      />
    ),
    isIndividual && (
      <CoachContactForm
        key="coach-contact-modal"
        primaryColor={primaryColor}
        open={coachContactOpen}
        toggle={() => setCoachContactOpen((p) => !p)}
      />
    ),
  ];
};

export default Sidebar;
